import { jncyURL, siteURL } from '@/configs/Constant';
import { isMobile } from '@/utils/platform';
export const gotoHomePage = () => {
  window.location.href = location.origin;
};
/**
 * @description 跳转到课程列表页（栏目树/左侧菜单/三级栏目）
 */
export function gotoCourseListByCatalog(item: { innercode: string; name: string }) {
  window.location.href = `./studyCourseList.html?knowledgeType=${item.innercode}&searchType=Course&knowledgeName=${item.name}`;
}

/**
 * @description 跳转到课程列表页（分类大块/三大类）
 */
export function gotoCourseListByCategory(item: { innerCode: string }) {
  window.location.href = `./studyCourseList.html?jobType=${item.innerCode}&searchType=Course`;
}

/**
 * @description 跳转到课程列表页（搜索）
 */
export function gotoCourseListBySearch(searchName: string) {
  window.location.href = `./studyCourseList.html?searchName=${searchName}&searchType=Course`;
}

/**
 * @description 跳转到课程列表页（tab更多按钮）
 */
export function gotoCourseListByTab(sort: 'publishDate' | 'isRecommend' | 'praiseCount') {
  window.location.href = `./studyCourseList.html?sort=${sort}&searchType=Course`;
}

/**
 * @description 跳转到课程详情页（新开标签页）
 */
export function gotoCourseDetailsPage(
  courseIDOrParams:
    | number
    | string
    | {
        courseID?: number | string;
        ID?: number | string;
        classID?: number | string;
        specialID?: number | string;
        selfStudy?: string;
        source?: string;
      },
  source?: string,
  isNewTab = true,
) {
  let courseID: number | string;
  let classID: number | string | undefined;
  let specialID: number | string | undefined;
  let selfStudy: string | undefined;
  let finalSource: string | undefined;

  if (typeof courseIDOrParams === 'object' && courseIDOrParams !== null) {
    courseID = courseIDOrParams.courseID || courseIDOrParams.ID || '';
    classID = courseIDOrParams.classID;
    specialID = courseIDOrParams.specialID;
    selfStudy = courseIDOrParams.selfStudy;
    finalSource = courseIDOrParams.source;
  } else {
    courseID = courseIDOrParams;
    finalSource = source;
  }

  // 构建 URL: courseID 和 source 在 location.search，学习模式参数在 router.query
  // 格式: ./courseDetails.html?courseID=xxx&source=xxx#/?classID=xxx
  let url = `./courseDetails.html?courseID=${courseID}`;
  // location.search 参数
  if (source === 'master') {
    if(!finalSource){
      finalSource = 'master'
    }
    url += `&source=${finalSource}`;
  }

  // router.query 参数（hash 模式）
  const queryParams: string[] = [];
  if (classID) queryParams.push(`classID=${classID}`);
  if (specialID) queryParams.push(`specialID=${specialID}`);
  if (selfStudy) queryParams.push(`selfStudy=${selfStudy}`);

  if (queryParams.length > 0) {
    url += `#/?${queryParams.join('&')}`;
  }

  if (isNewTab && !isMobile.value) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
}

/**
 * @description 跳转到专题详情页（新开标签页）
 */
export function gotoSpecialDetailsPage(
  specialID: number | string,
  source?: string,
  moduleType?: string,
) {
  let url = `./specialDetails.html?specialID=${specialID}`;
  if (source) url += `&source=${source}`;
  if (moduleType) url += `&moduleType=${moduleType}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到试卷答题页
 */
export function gotoPaperPage(paperID: number | string) {
  const url = `${siteURL}html/paper.html?paperID=${paperID}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到试卷结果页
 */
export function gotoPaperResultPage(paperID: number | string) {
  const url = `${siteURL}html/paperResult.html?paperID=${paperID}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到登录页
 */
export function gotoLoginPage() {
  const url = './login.html';
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到课程播放页
 */
export function gotoCoursePlayPage(params: {
  courseID: string | number;
  videoID?: string | number;
  source?: string;
  classID?: string | number;
  specialID?: string | number;
  selfStudy?: string;
}) {
  // 构建 URL: courseID、videoID、hasPaper、source 在 location.search，学习模式参数在 router.query
  // 格式: ./coursePlay.html?courseID=xxx&videoID=xxx#/?classID=xxx
  let url = `./coursePlay.html?courseID=${params.courseID}`;

  // location.search 参数
  if (params.videoID) url += `&videoID=${params.videoID}`;
  if (params.source) url += `&source=${params.source}`;

  // router.query 参数（hash 模式）
  const queryParams: string[] = [];
  if (params.classID) queryParams.push(`classID=${params.classID}`);
  if (params.specialID) queryParams.push(`specialID=${params.specialID}`);
  if (params.selfStudy) queryParams.push(`selfStudy=${params.selfStudy}`);

  if (queryParams.length > 0) {
    url += `#/?${queryParams.join('&')}`;
  }

  window.location.href = url;
}

/**
 * @description 跳转到课程购买页
 */
export function gotoCourseBuyPage(buyLink: string) {
  window.location.href = buyLink;
}

/**
 * @description 跳转到试卷答题页
 */
export function gotoExamPage(params: { id: string | number; type: number; key_success: string }) {
  window.location.href = `/v/#/exam/startExam?id=${params.id}&type=${params.type}&key_success=${params.key_success}`;
}

/**
 * @description 跳转到试卷结果页
 */
export function gotoExamResultPage(id: string | number) {
  window.location.href = `/v/#/exam/answerPaper?id=${id}`;
}

/**
 * @description 跳转到课程中心
 */
export function gotoCourseIndexPage() {
  window.location.href = './courseIndex.html';
}

/**
 * @description 跳转到课程列表页（栏目筛选/关键词搜索）
 */
export function gotoEnterpriseCourseListPage(params: { innercode?: string; searchName?: string }) {
  let url = './enterpriseCourseIndex.html';
  const query: string[] = [];
  if (params.innercode) query.push(`innercode=${params.innercode}`);
  if (params.searchName) query.push(`searchName=${encodeURIComponent(params.searchName)}`);
  if (query.length) url += '?' + query.join('&');
  window.location.href = url;
}

/**
 * @description 跳转到图书详情页（使用 detailPath，新开标签页）
 */
export function gotoBookDetailsPage(detailPath: string) {
  if (isMobile.value) {
    window.location.href = detailPath;
  } else {
    window.open(detailPath, '_blank');
  }
}

/**
 * @description 跳转到讲师详情页（新开标签页）
 */
export function gotoTeacherDetailsPage(teacherID: number | string, source?: string) {
  let url = '';
  if (source === 'master') {
    url = jncyURL + 'masterDetail.html?ID=' + teacherID;
  } else {
    url = `./teacherDetail.html?teacherID=${teacherID}`;
  }
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到新闻详情页（使用 detailPath，新开标签页）
 */
export function gotoNewsDetailsPage(detailPath: string) {
  if (isMobile.value) {
    window.location.href = detailPath;
  } else {
    window.open(detailPath, '_blank');
  }
}

/**
 * @description 跳转到直播详情页（使用 detailPath，新开标签页）
 */
export function gotoLiveDetailsPage(liveID: string, source?: string) {
  let url = `${siteURL}html/liveDetails.html?liveCourseID=${liveID}`;
  if (source) url += `&source=${source}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到直播播放页
 */
export function gotoLivePlayPage(liveID: number | string, source?: string) {
  let url = `./livePlay.html?liveID=${liveID}`;
  if (source) url += `&source=${source}`;
  window.location.href = url;
}

/**
 * @description 跳转到面授培训详情页（使用 detailPath，新开标签页）
 */
export function gotoFaceTrainDetailsPage(detailPath: string) {
  if (isMobile.value) {
    window.location.href = detailPath;
  } else {
    window.open(detailPath, '_blank');
  }
}

/**
 * @description 跳转到文库详情页（使用 detailPath，新开标签页）
 */
export function gotoLibraryDetailsPage(detailPath: string) {
  if (isMobile.value) {
    window.location.href = detailPath;
  } else {
    window.open(detailPath, '_blank');
  }
}

/**
 * @description 跳转到文库阅读页
 */
export function gotoLibraryReaderPage(libraryID: number | string, source?: string) {
  let url = `./libraryDetails.html?id=${libraryID}`;
  if (source) url += `&source=${source}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到刷题策略页面（使用 detailPath，新开标签页）
 */
export function gotoExamDetailsPage(detailPath: string) {
  if (isMobile.value) {
    window.location.href = detailPath;
  } else {
    window.open(detailPath, '_blank');
  }
}

/**
 * @description 跳转到文库阅读页
 */
export function gotoknowledgeDetailPage(nowledgeid: number | string, source?: string) {
  let url = `./knowledgeDetail.html?id=${nowledgeid}`;
  if (source) url += `&source=${source}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到课程检索页-更多课程-总效果更多;
 */
export function handleMoreCourse() {
  const url = `${siteURL}html/searchResult.html?categoryType=course`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到直播检索页-更多直播-总效果更多;
 */
export function handleMoreLive() {
  const url = `${siteURL}html/searchResult.html?categoryType=live&publishDate=desc`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到课程检索页-商品分类-点击左侧栏菜单;
 */
export function handleCategoryChange(item: any, child?: any) {
  const url = `${siteURL}html/searchResult.html?moduleType=${item.type}&categoryType=course&category=${child?.innerCode || ''}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到课程检索页-公开课程-总效果更多;
 */
export function handleMorepublic() {
  const url = `${siteURL}html/searchResult.html?type=PublicCourse&categoryType=course`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到课程检索页-搜索关键词;
 */
export function gotoSearchPage(searchName: string) {
  const url = `${siteURL}html/searchResult.html?searchName=${searchName}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到文库检索页-搜索文库;
 */
export function searchResultlibrary(innercode: string) {
  const url = `${siteURL}html/searchResult.html?&categoryType=library&docType=${innercode}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

// 立即购买
export async function purchase(url: string) {
  if (isMobile.value) {
    location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

// 跳转到直播回放页
export function gotoLivePlaybackPage(liveID: number | string, liveCourseID?: number | string) {
  let url = `${siteURL}html/livePlayback.html`;
  const fullUrl = `${url}?liveID=${liveID}&liveCourseID=${liveCourseID}`;

  if (isMobile.value) {
    window.location.href = fullUrl;
  } else {
    window.open(fullUrl, '_blank');
  }
}

/**
 * @description 跳转到刷题策略详情页
 */
export function gotoExamQuestionDetailsPage(examQuestionID: string | number) {
  const url = `${siteURL}html/examQuestionDetail.html?id=${examQuestionID}`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到文库上传页
 */
export function gotoLibraryUploadPage() {
  const url = `${siteURL}html/uploadFile.html`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}

/**
 * @description 跳转到资源中心
 */
export function toEnterpriseResource() {
  const url = `${siteURL}html/enterpriseCourseIndex.html`;
  if (isMobile.value) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
}
